<template>
    <div class="biz-effect">
        <div class="landing-container wrap">
            <div class="title">
                <span v-if="houseAmount != 0">我有<span class="mark">{{houseAmount}}</span>間房源，</span><span>使用飛豬管家後的成果</span>
            </div>
            <div class="title-mb">
                <span v-if="houseAmount != 0">我有<span class="mark">{{houseAmount}}</span>間房源<br></span><span>使用飛豬管家後的成果</span>
            </div>
            <div class="effect-num">
                <div class="block">
                    <div class="text one">
                        空房率降低
                    </div>
                    <div class="percent">
                        <img src="@/assets/img/landingPage/bussiness/arrow_green.svg" alt="">
                        50%
                    </div>
                </div>
                <div class="block">
                    <div class="text two">
                        支出成本降低
                    </div>
                    <div class="percent">
                        <img src="@/assets/img/landingPage/bussiness/arrow_green.svg" alt="">
                        80%
                    </div>
                </div>
                <div class="block">
                    <div class="text three">
                        業務效率提升
                    </div>
                    <div class="percent">
                        <img src="@/assets/img/landingPage/bussiness/arrow.svg" alt="">
                        67%
                    </div>
                </div>
                <div class="block">
                    <div class="text four">
                        行政成本降低
                    </div>
                    <div class="percent">
                        <img src="@/assets/img/landingPage/bussiness/arrow_green.svg" alt="">
                        40%
                    </div>
                </div>
            </div>
            <div class="free-register">
                <div class="corner c-top"></div>
                <div class="corner c-btm"></div>
                <img class="free-bg" src="@/assets/img/landingPage/bussiness/effect.svg" alt="">
                <div class="content">
                    <div class="text">
                        飛豬管家解決你的租房大小事
                    </div>
                    <button class="switch-btn" @click="$router.push({name: 'bizLogin', query: {'mode': 'register'}})">立即免費註冊</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        return{
        }
    },
    methods: {
        
    },
    computed: {
        ...mapGetters({
            houseAmount: 'GET_HOUSE_AMOUNT'
        })
    },
}
</script>
<style lang="scss" scoped>
    .biz-effect{
        background-color: #292625;
        display: flex;
        justify-content: center;
        .wrap{
            position: relative;
            color: white;
            .title{
                font-size: 36px;
                font-weight: 500;
                margin-top: 50px;
                margin-bottom: 72px;
                text-align: center;
                letter-spacing: 2px;
                .mark{
                    font-size: 50px;
                    color: #33afff;
                    text-decoration: underline;
                }
            }
            .title-mb{
                display: none;
            }
            .effect-num{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 50px;
                .block{
                    .text{
                        position: relative;
                        font-size: 20px;
                        margin-bottom: 14px;
                        &.one{
                            left: 17px;
                        }
                        &.two{
                            left: 12px;
                        }
                        &.three{
                            left: 12px;
                        }
                        &.four{
                            left: 7px;
                        }
                    }
                    .percent{
                        display: flex;
                        align-items: center;
                        font-size: 40px;
                    }
                }
            }
            .free-register{
                position: relative;
                margin-left: 20px;
                margin-bottom: 87px;
                .content{
                    position: absolute;
                    top: 103px;
                    left: 264px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    .text{
                        font-size: 36px;
                        font-weight: bold;
                        color: #292625;
                        margin-bottom: 48px;
                    }
                    .switch-btn{
                        width: 232px;
                        height: 66px;
                        box-shadow: 0 11px 15px -4px #ff8e8e;
                        background-color: #ff6868;
                        color: #fff;
                    }
                }
            }

        }
        
    }
    @media screen and (max-width: 1100px) {
        .biz-effect{
            display: flex;
            justify-content: center;
            .wrap{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                width: unset;
                color: white;
                .title{
                    display: none;
                }
                .title-mb{
                    display: block;
                    width: 260px;
                    font-size: 24px;
                    font-weight: 500;
                    margin-top: 25px;
                    margin-bottom: 48px;
                    text-align: center;
                    letter-spacing: 2px;
                    line-height: 1.7;
                    .mark{
                        font-size: 32px;
                        color: #33afff;
                        text-decoration: underline;
                    }
                }
                .effect-num{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    width: 100%;
                    margin-bottom: 0px;
                    .block{
                        width: 50%;
                        margin-bottom: 94px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        .text{
                            font-size: 16px;
                            margin-bottom: 12px;
                            &.one{
                                left: 6px;
                            }
                            &.two{
                                left: 6px;
                            }
                            &.three{
                                left: 12px;
                            }
                            &.four{
                                left: 7px;
                            }
                        }
                        .percent{
                            font-size: 30px;
                            margin-bottom: 22px;
                            img{
                                width: 35px;
                            }
                        }
                    }
                }
                .free-register{
                    position: relative;
                    width: 100%;
                    height: 190px;
                    margin-left: 0px;
                    margin-bottom: 87px;
                    background: #fff8e9;
                    border-radius: 50px;
                    .free-bg{
                        display: none;
                    }
                    .corner{
                        position: absolute;
                        width: 45px;
                        height: 45px;
                        background: #fff8e9;
                        &.c-top{
                            top: 0px;
                            right: 0px;
                        }
                        &.c-btm{
                            bottom: 0;
                            left: 0;
                        }
                    }
                    .content{
                        position: relative;
                        top: unset;
                        left: unset;
                        margin-top: 32px;
                        .text{
                            font-size: 22px;
                            margin-bottom: 40px;
                        }
                        .switch-btn{
                            width: 186px;
                            height: 53px;
                            font-size: 18px;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/bussiness/effect.vue